define('modules/start/products/email/status/view',['require','exports','module','env','views/BaseView','ldsh!./template'],function (require, exports, module) {
  "use strict";

  var Config = require("env");
  var BaseView = require("views/BaseView");

  var Layout = BaseView.extend({
    template: require("ldsh!./template"),
    events: {},

    initialize: function () {
      if (this.productDetails) {
        this.listenTo(this.productDetails, "sync", this.render);
      }
    },

    serialize: function () {
      var balance = this.productDetails.get("balance");
      return {
        productDetails: this.productDetails,
        servicePlan: this.servicePlan,
        numEmailsAvailable: this.productDetails.get("numEmailsAvailable"),
        paymentsUrl: Config.paymentsUrl + "account/products",
        billingDataUrl: Config.paymentsUrl + "account/my-rate",
        dailyEmailsAvailable: balance && balance.numOfEmailsPerDay,
        dailyEmailsRemaining: balance && balance.numOfEmailsPerDayLeft,
        excessLimitIsOver: this.checkExcessLimitIsOver(
          balance && balance.canExceedEmailLimit,
          balance && balance.numEmails,
          balance && balance.numOfEmailsPerMonth
        ),
        emailExcess: this.productDetails.get("emailExcess"),
      };
    },
    checkExcessLimitIsOver: function (canExceedEmailLimit, left, max) {
      return canExceedEmailLimit && left <= (max * 20) / 100;
    },
    afterRender: function () {
      $(".ayuda-context").popover();
    },
  });

  module.exports = Layout;
});

